// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22ad9ba0","455":"2dd3a158","977":"eab51b9d"}[chunkId] + ".chunk.js";
};